import { Control } from "react-hook-form";
import styled from "@emotion/styled";

import { Flex } from "../../../../styles/utility-components";
import { LeadFilters } from "../utils";
import AssigneeFilterContent from "./Assignee";
import BuyersFilterContent from "./Buyers";
import CreatedByFilterContent from "./CreatedBy";
import CreatedDateFilterContent from "./CreatedDate";
import ExpiryDateFilterContent from "./ExpiryDate";
import LastUpdatedDateFilterContent from "./LastUpdatedDate";
import StageFilterContent from "./Stage";
import SuppliersFilterContent from "./Suppliers";
import TeamFilterContent from "./Team";
import ValueFilterContent from "./Value";

export interface LeadFilterContentProps {
  control: Control<LeadFilters, unknown>;
  data?: LeadFilters;
}

export const StyledFilterContent = styled(Flex)({
  flexDirection: "column",
  gap: 16,
  padding: "24px",
  paddingTop: "2px",
});

export const LeadFilterContents = {
  assignedTo: AssigneeFilterContent,
  createdBy: CreatedByFilterContent,
  team: TeamFilterContent,
  stage: StageFilterContent,
  value: ValueFilterContent,
  createdDate: CreatedDateFilterContent,
  lastUpdated: LastUpdatedDateFilterContent,
  expiryDate: ExpiryDateFilterContent,
  buyers: BuyersFilterContent,
  suppliers: SuppliersFilterContent,
};
